import React from 'react';
import { WrappedFieldProps } from 'redux-form';

const customCheckStyles = (value: boolean) =>
  value ? { backgroundColor: '#30b033', border: 'none' } : {};

const customIStyles = (value: boolean) => (value ? { color: '#FFFFFF' } : {});

interface IFormCheckboxProps {
  text: string;
}

export default function FormCheckbox(
  props: WrappedFieldProps & IFormCheckboxProps,
) {
  const {
    input,
    text,
    meta: { touched, error },
  } = props;
  return (
    <>
      <label htmlFor={input.name} className="custom-check">
        <div className="custom-check--container">
          <input {...input} id={input.name} type="checkbox" />
          <div
            className="custom-check--bg"
            style={customCheckStyles(input.value)}
          />
          <i className="material-icons" style={customIStyles(input.value)}>
            check
          </i>
        </div>
        <span>{text}</span>
      </label>
      {touched && error && ((input.name !== "declarationCard" && <small className="invalid">{error}</small>) || (input.name === "declarationCard" && <div className="sf-alert sf-alert--warning"><p className='px-16 mb0 text-left'>{error}</p></div>))}
    </>
  );
}
